<template>
  <v-navigation-drawer :value="open" app fixed persistent mobile-breakpoint="991" width="260" class="primary">
    <!-- <v-layout column justify-center fill-height align-center>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-layout>-->
    <v-layout class tag="v-list" column>
      <v-list-item>
        <v-list-item-title class="title text-xs-center">
          <img
            class="branding-logo"
            v-if="$store.getters['business/activeBusinessBranding'].logo_url"
            :src="$store.getters['business/activeBusinessBranding'].logo_url"
          />
          <img class="branding-logo" v-else src="../../assets/images/uno-logo.png" />
        </v-list-item-title>
      </v-list-item>
      <v-divider class="mt-2" />
      <v-list>
        <span v-for="(item, index) in allApplications" :key="`${item.name}_${index}`">
          <v-hover v-slot:default="{ hover }">
            <v-list-item
              :to="item.path"
              active-class="accent lighten-1"
              class="left-nav-item"
              :class="{'accent': hover}"
              dark
            >
              <v-list-item-title >{{ item.meta.nav.name }}</v-list-item-title>
            </v-list-item>
          </v-hover>
        </span>
      </v-list>
    </v-layout>
  </v-navigation-drawer>
</template>
<script>
export default {
  data () {
    return {
      selectedNav: 0
    }
  },
  props: {
    open: {
      default: true,
      required: true
    }
  },
  mounted () {
  },
  methods: {
    // changeApplication (app) {
    //   app.selected = true
    //   // this.loadLocationsForApplication(app.meta.identifier)
    //   this.$router.push(app.path).catch(() => {
    //     this.snackbar({
    //       text: `You are already in '${this.$route.meta.nav.name}'`
    //     })
    //   })
    // }
  },
  computed: {
    allApplications () {
      let allRoutes = this.$router.options.routes
      return allRoutes.filter(route => {
        return route.meta && route.meta.nav && route.meta.nav.display
      })
    }
  }
}
</script>
<style scoped>
.branding-logo {
  max-width: 80%;
  height: 60px;
  width: auto;
}
.settings.left-nav-item {
  position: absolute;
  width: 100%;
  bottom: 0;
}
</style>
